import { UseFeatureFlagTranslatedPayloadProps } from 'hooks/types'
import { useGetLanguage } from 'hooks/useGetLanguage'
import { useFeatureFlagEnabled, useFeatureFlagPayload, useFeatureFlagVariantKey } from 'posthog-js/react'
import { IS_PROD } from 'constants/envs'

export const useFeatureFlagTranslatedPayload = ({ key, fallback, debug }: UseFeatureFlagTranslatedPayloadProps): string => {
  // i18n
  const language = useGetLanguage()

  // Posthog
  const flagPayload = useFeatureFlagPayload(key)
  const flagVariant = useFeatureFlagVariantKey(key)
  const flagEnabled = useFeatureFlagEnabled(key)

  if (debug && !IS_PROD) {
    console.log(`Feature Flag: ${key}`, {
      flagPayload,
      flagVariant,
      flagEnabled,
      language
    })
  }

  // Return the translated payload if it exists, otherwise return the fallback
  return flagPayload && typeof flagPayload === 'object' && language in flagPayload ? flagPayload[language] : fallback
}
